<template>
  <div id="about">
  		<Header msg="/communication" />
		<div style='height: 48px;'></div>
		<div class="aboutPage">
			<div :style="{backgroundImage:'url('+require('@/assets/about/communication.jpg')+')'}" class='aboutBanner'>
				<div class='bannerName1'>「卓越Elite」</div>
				<div class='bannerName2'>国际营养师交流计划</div>
				<div class='bannerTitle'>{{bannerTitle}}</div>
			</div>
	
			
			<div class='communicationBox'>
				<div class='boxItem'>
					<img :src="img1" alt="">
					<div>NNRC国际营养交流论坛</div>
				</div>
				<div class='boxItem'>
					<img :src="img2" alt="">
					<div>最新的营养咨询与膳食科学发现</div>
				</div>
				<div class='boxItem'>
					<img :src="img3" alt="">
					<div>特色课题众创与成果分享</div>
				</div>
			</div>
			 <router-link to="/Contact" class='communicationBtn' >申请加入</router-link>
		</div>

  		<Foot />
  </div>
</template>
<script>
import Header from '@/components/header.vue'
import Foot from '@/components/foot.vue'


export default {
  name: 'Communication',
  components: {
      Header,
      Foot,
  },
  data:()=>{
  	return{
  		bannerTitle:'为分享前沿营养理论和实践经验，促进中美营养师的交流，NUTRIPACKS开设非营利性项目——"卓越Elite”营养师提升培养计划，旨在推广更科学的营养观念、更专业的营养知识、更健康的生活方式。',
  		img1:require('@/assets/luntan.png'),
  		img2:require('@/assets/faxian.png'),
  		img3:require('@/assets/fenxiangcopy.png'),
  	}
  },
 mounted:function(){
  	
  	 $('html,body').animate({scrollTop:0},10);
  },
}
</script>
<style>
#about{
	width: 100%;
	height:100%;
}
.aboutPage{
	
}
.aboutBanner{
	max-width: 100vw;
	width: 100%;
	height:45vw;
	max-height:640px;
	background-repeat: no-repeat;
	background-size: 100%;
	background-position:center;
	-moz-background-size: 100% 100%;
	overflow: hidden;
}
.bannerName{
	height:50px;
	font-size:36px;
	font-family:PingFangSC-Medium;
	font-weight:500;
	color:rgba(255,255,255,1);
	line-height:50px;
	letter-spacing:2px;
	padding: 16vw 0 80px;
}
.bannerName1{
	font-size:30px;
	font-family:PingFangSC-Medium;
	font-weight:500;
	color:rgba(255,255,255,1);
	line-height:60px;
	letter-spacing:2px;
	margin-top:160px;
	position: relative;
}
.bannerName1:after{
	position: absolute;
	width: 164px;
	height:9px;
	bottom:-3px;
	left:50%;
	margin-left: -82px;
	content: " ";
  	display: block;
	background:rgba(183,137,117,1);
	border-radius:6px;
}
.bannerName2{
	font-size:30px;
	font-family:PingFangSC-Medium;
	font-weight:500;
	color:rgba(255,255,255,1);
	line-height:60px;
	letter-spacing:2px;
	margin-bottom: 30px;
}
.bannerTitle{
	width:466px;
	font-size:18px;
	font-family:PingFangSC-Regular;
	font-weight:400;
	color:rgba(255,255,255,1);
	line-height:25px;
	letter-spacing:1px;
	margin:0 auto;
}

.communicationBox{
	width: 100%;
	display: flex;
	justify-content: center;
	overflow: hidden;
	margin:140px 0 170px;
}
.boxItem{
	width: 275px;
	text-align:center;
}
.boxItem img{
	width: 75px;
	height:75px;
	display: block;
	margin:0 auto 28px;
}
.boxItem div{
font-size:18px;
font-family:PingFangSC-Regular;
font-weight:400;
color:rgba(20,20,20,1);
line-height:25px;
}
.communicationBtn{
	display: block;
	width:475px;
	height:75px;
	background:rgba(194,94,77,1);
	border-radius:38px;
	border:1px solid rgba(151,151,151,1);
	font-size:24px;
	font-family:PingFangSC-Regular;
	font-weight:400;
	color:rgba(255,255,255,1);
	line-height:75px;
	margin:0 auto 142px;
	cursor:pointer;
	text-decoration: none;
}
a.communicationBtn:hover{
text-decoration: none;
color:rgba(255,255,255,1);
}
</style>